var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 1.24957C18.1913 1.24969 18.75 1.80824 18.75 2.49957C18.7498 3.19072 18.1912 3.74946 17.5 3.74957H3.125C2.78125 3.74957 2.5 4.03082 2.5 4.37457C2.50023 4.71814 2.78139 4.99957 3.125 4.99957H17.5C18.8788 4.99969 20 6.12074 20 7.49957V16.2496C19.9998 17.6282 18.8787 18.7495 17.5 18.7496H2.5C1.12123 18.7496 0.000223686 17.6283 0 16.2496V3.74957C0 2.37067 1.12109 1.24957 2.5 1.24957H17.5ZM10.0869 15.6236C10.7651 15.6155 11.4134 15.3571 11.8906 14.9029C12.3678 14.4487 12.6358 13.8351 12.6377 13.1959C12.6394 12.5568 12.3748 11.9426 11.9004 11.4859C11.4259 11.0292 10.7797 10.7663 10.1016 10.7545L10.0869 15.6236ZM9.77051 8.1236C9.0924 8.13178 8.44488 8.39113 7.96777 8.84528C7.49075 9.29946 7.22256 9.91224 7.2207 10.5513C7.21892 11.1904 7.48354 11.8046 7.95801 12.2613C8.34631 12.635 8.85 12.8749 9.3916 12.9576L7.00098 12.9517C7.00096 12.958 7.001 12.9651 7.00098 12.9722C6.99942 13.6651 7.28592 14.3312 7.7998 14.8267C8.3138 15.3223 9.01386 15.6083 9.74902 15.6226L9.75684 12.9927L9.77051 8.1236ZM10.1035 10.4673L12.8428 10.4742C12.7672 9.83693 12.4478 9.24744 11.9453 8.815C11.4428 8.38259 10.7906 8.13682 10.1104 8.1236L10.1035 10.4673Z",
    fill: "#54FF99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.84026715a4d79745d07223f0e42f7ae7.svg";
export { ForwardRef as ReactComponent };